var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.03,
    height: 36.75,
    viewBox: "0 0 28.03 36.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5208",
    "data-name": "Path 5208",
    d: "M15.9-14.062q3.758,0,5.555,1.467a6.82,6.82,0,0,1,2.163,4.748L24.548,0H29.81l-.99-8.415a11.981,11.981,0,0,0-1.439-4.913,6.019,6.019,0,0,0-3.153-2.539,16.177,16.177,0,0,0-5.472-.761Zm1.668-17.031a6.988,6.988,0,0,1,4.969,1.65,6.047,6.047,0,0,1,1.76,4.638,5.747,5.747,0,0,1-1.76,4.5,7.166,7.166,0,0,1-4.969,1.586H8.158V-31.093Zm1.192,15.381a12.825,12.825,0,0,0,5.747-1.21,9.192,9.192,0,0,0,3.813-3.392,9.3,9.3,0,0,0,1.366-5.042,10.327,10.327,0,0,0-1.421-5.473,9.608,9.608,0,0,0-3.988-3.63A13.123,13.123,0,0,0,18.3-35.75H2.842V0H8.158V-14.062H18.315Z",
    transform: "translate(-2.342 36.25)",
    fill: "#090b0a",
    stroke: "#090b0a",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.48cc2ab404dda9e2323e18e85f06d31e.svg";
export { ForwardRef as ReactComponent };